import { PermissionType } from './PermissionType'
export interface PermissionResponseAttributesType {
  name: string
  relationContactId: string
  system: string
  privileges: string[]
}

export interface PermissionResponseItemType {
  type: string
  id: string
  attributes: PermissionResponseAttributesType
}

export interface PermissionsResponse {
  data: Array<PermissionResponseItemType>
}

export const isPermissionsReponseType = (response: any): response is PermissionsResponse => {
  return (
    response && 'data' in response && response['data'].length >= 1 && isPermissionsResponseArrayType(response['data'])
  )
}

export const isPermissionsResponseArrayType = (permissions: any): permissions is PermissionType => {
  if (permissions.length === 0) {
    return true
  }
  return (
    'type' in permissions[0] &&
    'id' in permissions[0] &&
    'attributes' in permissions[0] &&
    'privileges' in permissions[0]['attributes'] &&
    typeof permissions[0]['attributes'].privileges == 'object'
  )
}
